import axios from "axios";

const baseUrl = process.env.REACT_APP_API;

const getChannelsList = () => {
  return axios.get(`${baseUrl}/kids-teach-kids/`);
};

const getMoreChannelsList = (page) => {
  return axios.get(`${baseUrl}/kids-teach-kids/?page=${page}`);
};

const getKidChannel = (channelId) => {
  return axios.get(`${baseUrl}/kids-teach-kids/${channelId}/`);
};

const getMoreKidChannel = (channelId, page) => {
  return axios.get(`${baseUrl}/kids-teach-kids/${channelId}/?page=${page}`);
};

const postNewChannels = (data) => {
  return axios.post(`${baseUrl}/kids-teach-kids/`, data);
};

const postNewVideo = (channelId, data) => {
  return axios.post(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/upload/`,
    data
  );
};

const patchKidChannel = (channelId, data) => {
  return axios.patch(`${baseUrl}/kids-teach-kids/${channelId}/`, data);
};

const getChannelVideo = (channelId, videoId) => {
  return axios.get(`${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/`);
}

const addChannelVideoView = (channelId, videoId) => {
  return axios.get(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/watch/?started=True`
  );
};

const addChannelVideoPoint = (channelId, videoId) => {
  return axios.get(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/watch/?ended=True`
  );
};

const addVideoLike = (channelId, videoId) => {
  return axios.get(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/liked/`
  );
};

const deleteVideo = (channelId, videoId) => {
  return axios.delete(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/`
  );
};
const addChannelSubscriber = (channelId) => {
  return axios.post(`${baseUrl}/kids-teach-kids/${channelId}/add_subscriber/`);
};
const addChannelVideoComment = (channelId, videoId, text, parent) => {
  return axios.post(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/add_comment/`,
    { text, parent},
    { withCredentials: true }
  );
};
const deleteChannelVideoComment = (channelId, videoId, commentId) => {
  return axios.post(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/delete_comment/`,
    { comment_id: commentId },
    { withCredentials: true }
  );
};
const reportChannelVideoComment = (channelId, videoId, commentId) => {
  return axios.post(
    `${baseUrl}/kids-teach-kids/channels/${channelId}/video/${videoId}/report_comment/`,
    { comment_id: commentId },
    { withCredentials: true }
  );
};

export const getChannelByUser = (userId) => {
  return axios.get(
    `${baseUrl}/kids-teach-kids/channels/${userId}`,
    { withCredentials: true }
  );
};



const ktkService = {
  getChannelsList,
  getMoreChannelsList,
  getKidChannel,
  getMoreKidChannel,
  postNewChannels,
  postNewVideo,
  patchKidChannel,
  getChannelVideo,
  addChannelVideoView,
  addChannelVideoPoint,
  addVideoLike,
  deleteVideo,
  addChannelSubscriber,
  addChannelVideoComment,
  deleteChannelVideoComment,
  reportChannelVideoComment,
  getChannelByUser
};

export default ktkService;
